export default "__VITE_ASSET__54cb224e__"